module.exports = __webpack_public_path__ + "static/media/ic-menu.8236d321.svg";